.uxn-notification-bell {
	display: inline-flex;
	vertical-align: text-bottom; // middle
	align-items: center;
	cursor: pointer;
	user-select: none;

	svg {
		font-size: var(--ux-notification-bell-icon-font-size);
		width: 1em;
		height: 1em;
	}

	svg #indicator,
	svg #indicator-circle-mask {
		visibility: hidden;
	}

	svg.show-indicator #indicator,
	svg.show-indicator #indicator-circle-mask {
		visibility: visible;
	}

	ux-badge {
		box-sizing: content-box; //! missing in ux-badge (results in paddings not being added to min-width/min-height)
		margin-left: -0.5em;
	}
}
